import type {
  IssueState,
  IssueStateReason,
} from '@github-ui/server-persisted-queries/types/IssuePickerFilteringServerQuery'
import {IssueClosedIcon, IssueOpenedIcon, SkipIcon} from '@primer/octicons-react'

export function getIssueIconAndFill(state: IssueState, stateReason: IssueStateReason | null | undefined) {
  let icon = IssueOpenedIcon
  let fill = 'var(--fgColor-open)'

  if (state === 'CLOSED') {
    icon = stateReason === 'COMPLETED' ? IssueClosedIcon : SkipIcon
    fill = stateReason === 'COMPLETED' ? 'var(--fgColor-done)' : 'var(--fgColor-muted)'
  }

  return {icon, fill}
}
